import { useState, useEffect, useCallback } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    setVisible(window.scrollY > 600);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-24 right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-600 hover:bg-accent-500 hover:text-white hover:border-accent-500 transition-all duration-300"
      aria-label="Voltar ao topo"
      style={{ boxShadow: '0 4px 18px rgba(0,0,0,0.45)' }}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}